import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  display: inline-block;
`;

export const StyledWrapper = styled.div`
  display: flex;
  width: 13%;
  justify-content: space-between;
`;
